<div class="message message-warning">
  <%= error_messages.base_epic_insurance_validation_error %>
</div>
